import { lazy } from "react";
import { Outlet } from "react-router";
import { RoleGuard } from "../contexts/RoleGuard";
import { AuthGuard } from "../utils/AuthGuard";
import { ScreenLoader } from "../utils/ScreenLoader";
import { AbilityProvider } from "../contexts/AbilityContext";

const PreTransactionManagement = ScreenLoader(
  lazy(
    () => import("../screens/pretransaction-screen/PreTransactionManagement"),
  ),
);
const PreTransactionRequest = ScreenLoader(
  lazy(
    () =>
      import(
        "../screens/pretransactionrequest-screen/PreTransactionRequestManagement"
      ),
  ),
);
const ReconcileDeposit = ScreenLoader(
  lazy(() => import("../screens/reconcile-screen/ReconcileUserDeposit")),
);
const ReconcileWithdraw = ScreenLoader(
  lazy(() => import("../screens/reconcile-screen/ReconcileUserWithdraw")),
);
const PreTransactionNotMatchManagement = ScreenLoader(
  lazy(
    () =>
      import(
        "../screens/pretransaction-not-match-screen/PreTransactionNotMatchManagement"
      ),
  ),
);
const PreDepositTransaction = ScreenLoader(
  lazy(() => import("../screens/pretransaction-screen/PreDepositTransAdd")),
);
const PreWithdrawTransaction = ScreenLoader(
  lazy(() => import("../screens/pretransaction-screen/PreWithdrawTransAdd")),
);

export const PreTransactionRoute = () => ({
  path: "pre-transaction",
  element: (
    <AuthGuard>
      <Outlet />
    </AuthGuard>
  ),
  children: [
    {
      path: "deposit-withdraw",
      element: (
        <RoleGuard
          requiredPermission="pretransactionDepositWithdraw"
          requiredActions={["isRead"]}
        >
          <PreTransactionManagement />
        </RoleGuard>
      ),
    },
    {
      path: "request",
      element: (
        <RoleGuard
          requiredPermission="pretransactionRequest"
          requiredActions={["isRead"]}
        >
          <AbilityProvider>
            <PreTransactionRequest />
          </AbilityProvider>
        </RoleGuard>
      ),
    },
    {
      path: "matching",
      element: (
        <RoleGuard
          requiredPermission="pretransactionNotMatch"
          requiredActions={["isRead"]}
        >
          <PreTransactionNotMatchManagement />
        </RoleGuard>
      ),
    },
    {
      path: "reconcile-deposit",
      element: (
        <RoleGuard
          requiredPermission="pretransactionReconcileDeposit"
          requiredActions={["isRead", "isUpdate"]}
        >
          <ReconcileDeposit />
        </RoleGuard>
      ),
    },
    {
      path: "reconcile-withdraw",
      element: (
        <RoleGuard
          requiredPermission="pretransactionReconcileWithdraw"
          requiredActions={["isRead", "isUpdate"]}
        >
          <ReconcileWithdraw />
        </RoleGuard>
      ),
    },
    {
      path: "pre-deposit/:id",
      element: (
        <RoleGuard
          requiredPermission="memberManagement"
          requiredActions={["isCreate"]}
        >
          <PreDepositTransaction />
        </RoleGuard>
      ),
    },
    {
      path: "pre-withdraw/:id",
      element: (
        <RoleGuard
          requiredPermission="memberManagement"
          requiredActions={["isCreate"]}
        >
          <PreWithdrawTransaction />
        </RoleGuard>
      ),
    },
  ],
});